<template>

  <dialog_CustomerEdit v-if="dialog_show" :editDialogSwitch="editDialogSwitch" :customer="editingCustomer" :reloadForSync="reloadForSync" />
  <dialog_CustomerView v-if="viewer_show" :customer="editingCustomer" :oth_viewCustomer="viewCustomer" :reloadForSync = "reloadForSync"/>
  <dialog_CustomerTagEdit v-if="tag_edit_show" :tagEditSwitch="tagEditSwitch" :reloadTagList="reloadTagList" />
  <dialog_customerRegisterMulti v-if="CsutomerRegisterVisible" :registerDialogSwitch="registerDialogSwitch" :reloadForSync="reloadForSync"/>

  <!-- 일괄 태그 변경 다이얼로그 -->
  <div class="batch-tag-dialog" v-if="batchTagDialogShow">
    <div class="batch-tag-content">
      <h3>{{ batchTagMode === 'add' ? '태그 추가' : '태그 제거' }}</h3>
      <p>{{ selectedCustomers.length }}명의 고객에게 적용</p>
      <ul class="batch-tag-list">
        <li 
          v-for="tag in myAllTags" 
          :key="tag.name"
          :class="{ selected: batchSelectedTag === tag.name }"
          @click="batchSelectedTag = tag.name"
        >
          {{ tag.name }}
        </li>
      </ul>
      <div class="batch-tag-actions">
        <button @click="batchTagDialogShow = false">취소</button>
        <button class="primary" @click="executeBatchTag" :disabled="!batchSelectedTag">확인</button>
      </div>
    </div>
  </div>

  <!-- 더보기 메뉴 (ellipsis) -->
  <div class="more-menu-overlay" v-if="moreMenuShow" @click="moreMenuShow = false"></div>
  <div class="more-menu" v-if="moreMenuShow">
    <ul>
      <li class="menu-section-title">보기 형식</li>
      <li @click="setLayoutMode('list')" :class="{ active: layoutMode === 'list' }">
        <i class="ph ph-list"></i> 리스트형
      </li>
      <li @click="setLayoutMode('grid')" :class="{ active: layoutMode === 'grid' }">
        <i class="ph ph-grid-four"></i> 그리드형
      </li>
      <li class="menu-divider"></li>
      <li class="menu-section-title">표시 유형</li>
      <li @click="setMenuType('default')" :class="{ active: menuType === 'default' }">
        <i class="ph ph-user"></i> 기본형
      </li>
      <li @click="setMenuType('manage')" :class="{ active: menuType === 'manage' }">
        <i class="ph ph-clipboard-text"></i> 관리형
      </li>
      <li @click="setMenuType('sales')" :class="{ active: menuType === 'sales' }">
        <i class="ph ph-chart-line-up"></i> 영업형
      </li>
      <li class="menu-divider"></li>
      <li @click="getContactFromAMA(); moreMenuShow = false">
        <i class="ph ph-download-simple"></i> AMA 불러오기
      </li>
      <li class="disabled">
        <i class="ph ph-head-circuit"></i> 자동 관리
      </li>
    </ul>
  </div>

  <!-- 생성 메뉴 -->
  <div class="create-menu-overlay" v-if="createMenuShow" @click="createMenuShow = false"></div>
  <div class="create-menu" v-if="createMenuShow">
    <ul>
      <li @click="stepByStepMakeCustomer(); createMenuShow = false">
        <i class="ph ph-user-plus"></i>
        <div>
          <span>직접 등록</span>
          <small>고객 정보를 직접 입력합니다</small>
        </div>
      </li>
      <li @click="shareLink(`/event/register/${getMbid()}`); createMenuShow = false">
        <i class="ph ph-hand-deposit"></i>
        <div>
          <span>등록 요청</span>
          <small>고객에게 링크를 보내 정보를 받습니다</small>
        </div>
      </li>
    </ul>
  </div>

  <div class="download-loading" v-if="loadVisible">
    <DotLottieVue style="height: auto; width: 50%; aspect-ratio: 1/1;" autoplay loop src="https://lottie.host/07c88cb1-fd13-4661-9fa5-a1ce113d8869/IwifQwziou.lottie" />
    <h2>연락처 불러오는 중..</h2>
  </div>

  <div id="dialog-customer-manage-list" class="dialog">
    <span class="cls" @click="oth_showCustomerManageList(false)"></span>
    <div class="paper">
      
      <!-- Header 1: 타이틀 + 검색 -->
      <div class="header-row header-primary">
        <div class="header-left">
          <button class="btn-back" @click="oth_showCustomerManageList(false)">
            <i class="ph ph-arrow-left"></i>
          </button>
          <h1>
            고객리스트
            <span class="count-badge">{{ CustomerList.length }}</span>
          </h1>
        </div>
        <div class="header-right">
          <div class="search-box">
            <i class="ph ph-magnifying-glass"></i>
            <input 
              type="text" 
              placeholder="검색" 
              v-model="searchRef" 
              @keyup.enter="applyAllFilters()" 
              @input="searchInput"
            />
          </div>
        </div>
      </div>

      <!-- Header 2: 카테고리(태그) + 편집/더보기 -->
      <div class="header-row header-secondary">
        <div class="header-left">
          <!-- 편집모드: 전체선택 -->
          <div class="select-all" v-if="editMode">
            <label class="checkbox-wrapper">
              <input 
                type="checkbox" 
                :checked="isAllSelected" 
                :indeterminate="isPartialSelected"
                @change="toggleSelectAll"
              >
              <span>전체선택</span>
            </label>
            <span class="selected-count" v-if="selectedCustomers.length > 0">
              {{ selectedCustomers.length }}명 선택
            </span>
          </div>
          <!-- 일반모드: 태그 -->
          <ul class="tags" v-else>
            <li @click="toggleAllTags" :class="{ sel: selectedTags.length === 0 }">전체</li>
            <li @click="sortByBookmark" :class="{ sel: sortMode === 'bookmark' }">
              <i class="ph-bold ph-star"></i>
            </li>
            <li
              v-for="tag in myAllTags"
              :key="tag.name"
              :class="{ sel: selectedTags.includes(tag.name) }"
              @click="toggleTag(tag.name)"
            >
              {{ tag.name }}
            </li>
            <li @click="tagEditSwitch(true)" class="tag-add">
              <i class="ph-bold ph-plus"></i>
            </li>
          </ul>
        </div>
        <div class="header-right">
          <button 
            class="btn-icon"
            :class="{ active: editMode }"
            @click="toggleEditMode"
            :title="editMode ? '편집 취소' : '편집'"
          >
            <i class="ph" :class="editMode ? 'ph-x' : 'ph-pencil-simple'"></i>
          </button>
          <button 
            class="btn-icon"
            @click="moreMenuShow = !moreMenuShow"
            title="더보기"
            v-if="!editMode"
          >
            <i class="ph ph-dots-three-vertical"></i>
          </button>
        </div>
      </div>

      <!-- 리스트형 - default -->
      <div class="container-item" v-if="layoutMode === 'list' && menuType === 'default'">
        <div class="chapter">
          <span style="flex:1.6;">성명(호칭) 
            <button @click="toggleSort('name')">
              <i :class="getSortIcon('name')"></i>
            </button> 
          </span>
          <span style="flex:0.4;">관계 
            <button @click="toggleSort('m_type')">
              <i :class="getSortIcon('m_type')"></i>
            </button> 
          </span>
          <span>생일 
            <button @click="toggleSort('birth')">
              <i :class="getSortIcon('birth')"></i>
            </button> 
          </span>
          <span>추천알림 
            <button @click="toggleSort('recommend')">
              <i :class="getSortIcon('recommend')"></i>
            </button> 
          </span>
          <span>그룹 
            <button @click="toggleSort('tags')">
              <i :class="getSortIcon('tags')"></i>
            </button> 
          </span>
        </div>

        <div class="main-content">
          <ul>
            <template v-for="Customer in CustomerList" :key="Customer.idx">
              <li v-if="Customer.opt_visible" :class="{ 'selected-row': isSelected(Customer.idx) }">
                <div @click="handleRowClick(Customer)" style="flex:1.6;"> 
                  <div class="thumb-wrapper" :class="{ 'edit-mode': editMode, 'checked': isSelected(Customer.idx) }">
                    <img :src="Customer.thumb" alt="Profile Picture"> 
                    <div class="thumb-check" v-if="editMode" @click.stop="toggleSelect(Customer.idx)">
                      <i class="ph-bold" :class="isSelected(Customer.idx) ? 'ph-check-circle' : 'ph-circle'"></i>
                    </div>
                  </div>
                  <span>{{ Customer.name }} ({{ Customer.title }})</span>
                  <span class="badge badge-samename" v-if="Customer.same_name_count > 0">
                    동명 {{ Customer.same_name_count + 1 }}
                  </span>
                  <span class="distinguish-info" v-if="Customer.same_name_count > 0">
                    {{ getDistinguishInfo(Customer) }}
                  </span>
                  <div class="badges"></div>
                  <p class="bookmark" v-if="Customer.bookmark_idx"><i class="ph-fill ph-star"></i></p>
                </div>
                <div style="flex:0.4;" @click="handleRowClick(Customer)"> <span :class="Customer.m_type" class="m_type">{{ Customer.m_type || '?' }}</span> </div>
                <div @click="handleRowClick(Customer)"> <span>{{ formatBirth(Customer?.rrn?.split('-')[0]) }} ({{ genderChoser(Customer?.rrn?.split('-')[1]?.slice(0, 1)) }})</span> </div>
                <div @click="handleRowClick(Customer)"> <span>--</span> </div>
                <div @click="handleRowClick(Customer)" style="gap:6px; font-size:14px;"> <span v-for="tag in Customer.tags" v-bind:key="tag.idx">{{ tag }}</span> </div>
              </li>
            </template>
          </ul>
        </div>
      </div>

      <!-- 리스트형 - manage -->
      <div class="container-item" v-if="layoutMode === 'list' && menuType === 'manage'">
        <div class="chapter">
          <span>성명
            <button @click="toggleSort('name')">
              <i :class="getSortIcon('name')"></i>
            </button>
          </span>
          <span>관리등급
            <button @click="toggleSort('manage_rank')">
              <i :class="getSortIcon('manage_rank')"></i>
            </button>
          </span>
          <span>가족
            <button @click="toggleSort('rel_cnt')">
              <i :class="getSortIcon('rel_cnt')"></i>
            </button>
          </span>
          <span>미접촉
            <button @click="toggleSort('last_touch')">
              <i :class="getSortIcon('last_touch')"></i>
            </button>
          </span>
          <span>마지막 접촉이력</span>
          <span>이벤트</span>
        </div>

        <div class="main-content">
          <ul>
            <template v-for="Customer in CustomerList" :key="Customer.idx">
              <li v-if="Customer.opt_visible" :class="{ 'selected-row': isSelected(Customer.idx) }">
                <div @click="handleRowClick(Customer)"> 
                  <div class="thumb-wrapper" :class="{ 'edit-mode': editMode, 'checked': isSelected(Customer.idx) }">
                    <img :src="Customer.thumb" alt="Profile Picture"> 
                    <div class="thumb-check" v-if="editMode" @click.stop="toggleSelect(Customer.idx)">
                      <i class="ph-bold" :class="isSelected(Customer.idx) ? 'ph-check-circle' : 'ph-circle'"></i>
                    </div>
                  </div>
                  <span>{{ Customer.name }}</span> 
                  <p class="bookmark" v-if="Customer.bookmark_idx"><i class="ph-fill ph-star"></i></p> 
                </div>
                <div @click="handleRowClick(Customer)"> <span>{{ Customer.manage_rank }}</span> </div>
                <div @click="handleRowClick(Customer)"> <span> {{ Customer.rel_cnt }}인 </span> </div>
                <div @click="handleRowClick(Customer)" style="gap:6px;" :title="getLastTouchRate(Customer.last_touch).text"> <span> {{ dateToDays(Customer.last_touch) }}일 </span> <span style="color:black; font-size:14px; padding:2px; border-radius:6px;" :style="{background:getLastTouchRate(Customer.last_touch).color}">{{ getLastTouchRate(Customer.last_touch).name }}</span> </div>
                <div @click="handleRowClick(Customer)"> <span> --+ </span> </div>
                <div @click="handleRowClick(Customer)"> <span> -- </span> </div>
              </li>
            </template>
          </ul>
        </div>
      </div>

      <!-- 리스트형 - sales -->
      <div class="container-item" v-if="layoutMode === 'list' && menuType === 'sales'">
        <div class="chapter">
          <span>성명
            <button @click="toggleSort('name')">
              <i :class="getSortIcon('name')"></i>
            </button>
          </span>
          <span>직업
            <button @click="toggleSort('job')">
              <i :class="getSortIcon('job')"></i>
            </button>
          </span>
          <span>지역
            <button @click="toggleSort('location')">
              <i :class="getSortIcon('location')"></i>
            </button>
          </span>
          <span>보장 스케치</span>
          <span>가입</span>
          <span>청구</span>
        </div>

        <div class="main-content">
          <ul>
            <template v-for="Customer in CustomerList" :key="Customer.idx">
              <li v-if="Customer.opt_visible" :class="{ 'selected-row': isSelected(Customer.idx) }">
                <div @click="handleRowClick(Customer)"> 
                  <div class="thumb-wrapper" :class="{ 'edit-mode': editMode, 'checked': isSelected(Customer.idx) }">
                    <img :src="Customer.thumb" alt="Profile Picture"> 
                    <div class="thumb-check" v-if="editMode" @click.stop="toggleSelect(Customer.idx)">
                      <i class="ph-bold" :class="isSelected(Customer.idx) ? 'ph-check-circle' : 'ph-circle'"></i>
                    </div>
                  </div>
                  <span>{{ Customer.name }}</span> 
                  <p class="bookmark" v-if="Customer.bookmark_idx"><i class="ph-fill ph-star"></i></p> 
                </div>
                <div @click="handleRowClick(Customer)"> <span>{{ Customer.job || '모름' }} ({{ Customer.job_grade || '1' }}등급)</span> </div>
                <div @click="handleRowClick(Customer)"> <span> #{{ Customer.location || '모름' }} </span> </div>
                <div @click="handleRowClick(Customer)" style="gap:6px;" :title="getLastTouchRate(Customer.last_touch).text"> <span> {{ dateToDays(Customer.last_touch) }}일 </span> <span style="color:black; font-size:14px; padding:2px; border-radius:6px;" :style="{background:getLastTouchRate(Customer.last_touch).color}">{{ getLastTouchRate(Customer.last_touch).name }}</span> </div>
                <div @click="handleRowClick(Customer)"> <span> -- </span> </div>
                <div @click="handleRowClick(Customer)"> <span> -- </span> </div>
              </li>
            </template>
          </ul>
        </div>
      </div>

      <!-- 그리드형 뷰 -->
      <div class="container-item container-grid" v-if="layoutMode === 'grid'">
        <div class="grid-content">
          <template v-for="Customer in CustomerList" :key="Customer.idx">
            <div 
              class="customer-card" 
              v-if="Customer.opt_visible" 
              :class="{ 'selected-card': isSelected(Customer.idx) }"
              @click="handleRowClick(Customer)"
            >
              <div class="card-bookmark" v-if="Customer.bookmark_idx">
                <i class="ph-fill ph-star"></i>
              </div>
              <div class="card-thumb" :class="{ 'edit-mode': editMode, 'checked': isSelected(Customer.idx) }">
                <img :src="Customer.thumb" alt="Profile Picture">
                <div class="thumb-check" v-if="editMode" @click.stop="toggleSelect(Customer.idx)">
                  <i class="ph-bold" :class="isSelected(Customer.idx) ? 'ph-check-circle' : 'ph-circle'"></i>
                </div>
              </div>
              <div class="card-info">
                <h3>{{ Customer.name }}</h3>
                <p class="card-title">{{ Customer.title }}</p>
                <div class="card-tags" v-if="Customer.tags?.length">
                  <span v-for="tag in Customer.tags.slice(0, 2)" :key="tag">{{ tag }}</span>
                  <span v-if="Customer.tags.length > 2">+{{ Customer.tags.length - 2 }}</span>
                </div>
              </div>
              <div class="card-meta">
                <span class="m-type">{{ Customer.m_type }}</span>
                <span class="birth" v-if="Customer.rrn">{{ Customer.rrn.split('-')[0] }}</span>
              </div>
            </div>
          </template>
        </div>
      </div>

      <!-- 편집모드 액션바 -->
      <div class="batch-action-bar" v-if="editMode">
        <div class="batch-info">
          <span v-if="selectedCustomers.length === 0">고객을 선택하세요</span>
          <span v-else><strong>{{ selectedCustomers.length }}명</strong> 선택됨</span>
        </div>
        <div class="batch-actions">
          <button @click="openBatchTagDialog('add')" :disabled="selectedCustomers.length === 0">
            <i class="ph ph-tag"></i> 태그 추가
          </button>
          <button @click="openBatchTagDialog('remove')" :disabled="selectedCustomers.length === 0">
            <i class="ph ph-tag-simple-slash"></i> 태그 제거
          </button>
          <button @click="batchBookmark" :disabled="selectedCustomers.length === 0">
            <i class="ph ph-star"></i> 즐겨찾기
          </button>
          <button class="danger" @click="batchDelete" :disabled="selectedCustomers.length === 0">
            <i class="ph ph-trash"></i> 삭제
          </button>
        </div>
      </div>

      <!-- 생성 FAB 버튼 -->
      <button class="fab-create" @click="createMenuShow = !createMenuShow" v-if="!editMode">
        <i class="ph-bold ph-plus"></i>
      </button>

    </div>
  </div>
</template>


<script>
import { inject, ref, computed } from "vue";
import dialog_CustomerEdit from "@/components/dialogs/customerEdit.vue";
import dialog_CustomerView from "@/components/dialogs/customerView.vue";
import dialog_CustomerTagEdit from "@/components/dialogs/customerTagEdit.vue";
import dialog_customerRegisterMulti from '@/components/dialogs/customerRegisterMulti.vue';

import axios from 'axios';
import { DotLottieVue } from '@lottiefiles/dotlottie-vue'
import { useBackButton } from '@/utils/useBackBtn';

export default {
  components: {
    dialog_CustomerTagEdit,
    dialog_CustomerEdit,
    dialog_CustomerView,
    DotLottieVue,
    dialog_customerRegisterMulti,
  },
  data() {
    return {
      pageId:"CustomerList"
    };
  },
  props: {
    oth_showCustomerManageList: {
      type: Function,
      required: true
    }
  },
  setup(props) {
    const getMbid = inject('getMbid');
    const member_info = inject('member_info');
    const sql_query = inject('sql_query');
    const dialog_show = ref(false);
    const editingCustomer = ref(null);
    const calculateInsuAge = inject('calculateInsuAge');
    let basic_profile_url = `/imgs/unknow_user.png`;
    const CustomerList = ref([]);
    const viewer_show = ref(false);
    const loadVisible = ref(false);
    const menuType = ref("default");
    const riskLevel = ["비위험", "중위험", "고위험"];
    const formatKRPhone = inject('formatKRPhone');
    const myAllTags = ref([]);
    const selectedTags = ref([]);
    const tag_edit_show = ref(false);
    const sortMode = ref('');
    const layoutMode = ref('list');
    const checkCustomerMilestone = inject('checkCustomerMilestone');

    // 메뉴 상태
    const moreMenuShow = ref(false);
    const createMenuShow = ref(false);

    // 편집 모드 관련
    const editMode = ref(false);
    const selectedCustomers = ref([]);
    const batchTagDialogShow = ref(false);
    const batchTagMode = ref('add');
    const batchSelectedTag = ref('');

    useBackButton(() => {
      if (moreMenuShow.value) {
        moreMenuShow.value = false;
      } else if (createMenuShow.value) {
        createMenuShow.value = false;
      } else if (editMode.value) {
        editMode.value = false;
        selectedCustomers.value = [];
      } else {
        props.oth_showCustomerManageList(false);
      }
    });

    // 메뉴 타입 변경
    function setMenuType(type) {
      menuType.value = type;
      moreMenuShow.value = false;
    }

    // 레이아웃 모드 변경
    function setLayoutMode(mode) {
      layoutMode.value = mode;
      moreMenuShow.value = false;
    }

    // 편집모드 토글
    function toggleEditMode() {
      editMode.value = !editMode.value;
      if (!editMode.value) {
        selectedCustomers.value = [];
      }
    }

    // 선택 여부 확인
    function isSelected(idx) {
      return selectedCustomers.value.includes(idx);
    }

    // 개별 선택 토글
    function toggleSelect(idx) {
      const index = selectedCustomers.value.indexOf(idx);
      if (index > -1) {
        selectedCustomers.value.splice(index, 1);
      } else {
        selectedCustomers.value.push(idx);
      }
    }

    // 보이는 고객만 필터링
    const visibleCustomers = computed(() => {
      return CustomerList.value.filter(c => c.opt_visible);
    });

    // 전체 선택 여부
    const isAllSelected = computed(() => {
      if (visibleCustomers.value.length === 0) return false;
      return visibleCustomers.value.every(c => selectedCustomers.value.includes(c.idx));
    });

    // 부분 선택 여부
    const isPartialSelected = computed(() => {
      if (selectedCustomers.value.length === 0) return false;
      return !isAllSelected.value && selectedCustomers.value.length > 0;
    });

    // 전체 선택 토글
    function toggleSelectAll() {
      if (isAllSelected.value) {
        selectedCustomers.value = [];
      } else {
        selectedCustomers.value = visibleCustomers.value.map(c => c.idx);
      }
    }

    // 행 클릭 처리
    function handleRowClick(customer) {
      if (editMode.value) {
        toggleSelect(customer.idx);
      } else {
        viewCustomer(true, customer);
      }
    }

    // 일괄 삭제
    async function batchDelete() {
      if (selectedCustomers.value.length === 0) return;
      
      const count = selectedCustomers.value.length;
      if (!confirm(`선택한 ${count}명의 고객을 정말 삭제하시겠습니까?\n이 작업은 되돌릴 수 없습니다.`)) return;

      const idxList = selectedCustomers.value.join(',');
      await sql_query(`DELETE FROM customers WHERE idx IN (${idxList})`);
      
      selectedCustomers.value = [];
      await fetchCustomers();
    }

    // 태그 다이얼로그 열기
    function openBatchTagDialog(mode) {
      if (selectedCustomers.value.length === 0) return;
      batchTagMode.value = mode;
      batchSelectedTag.value = '';
      batchTagDialogShow.value = true;
    }

    // 일괄 태그 처리
    async function executeBatchTag() {
      if (!batchSelectedTag.value || selectedCustomers.value.length === 0) return;

      for (const idx of selectedCustomers.value) {
        const customer = CustomerList.value.find(c => c.idx === idx);
        if (!customer) continue;

        let tags = Array.isArray(customer.tags) ? [...customer.tags] : [];

        if (batchTagMode.value === 'add') {
          if (!tags.includes(batchSelectedTag.value)) {
            tags.push(batchSelectedTag.value);
          }
        } else {
          tags = tags.filter(t => t !== batchSelectedTag.value);
        }

        await sql_query(`UPDATE customers SET tags = '${JSON.stringify(tags)}' WHERE idx = ${idx}`);
      }

      batchTagDialogShow.value = false;
      await fetchCustomers();
    }

    // 일괄 즐겨찾기
    async function batchBookmark() {
      if (selectedCustomers.value.length === 0) return;

      for (const idx of selectedCustomers.value) {
        const customer = CustomerList.value.find(c => c.idx === idx);
        if (!customer) continue;

        if (customer.bookmark_idx) {
          await sql_query(`DELETE FROM bookmark WHERE idx = ${customer.bookmark_idx}`);
        } else {
          await sql_query(`
            INSERT INTO bookmark (mb_id, target_table, target_idx) 
            VALUES ('${getMbid()}', 'customers', ${idx})
          `);
        }
      }

      await fetchCustomers();
    }

    function sortByBookmark() {
      if (sortMode.value === 'bookmark') {
        sortMode.value = '';
        applyAllFilters();
      } else {
        sortMode.value = 'bookmark';
        sortState.value.field = null;
        sortState.value.direction = null;
        applyAllFilters();
      }
    }

    function reloadTagList() {
      fetchMyTags();
    }

    async function fetchMyTags() {
      let sql = `SELECT * FROM customer_tag WHERE mb_id = '${getMbid()}'`;
      let result = await sql_query(sql);
      myAllTags.value = result;
    }
    fetchMyTags();

    function tagEditSwitch(b) {
      tag_edit_show.value = b;
    }

    function getLastTouchRate(days) {
      if (days >= 90) return { name: "방치", color: "#000", text:"3달 이상 접촉 없음" };
      if (days >= 31) return { name: "위험", color: "#E3204A", text:"1달 이상 접촉 없음" };
      if (days >= 14) return { name: "주의", color: "#2E5BFF", text:"2주 이상 접촉 없음" };
      if (days >= 7)  return { name: "친밀", color: "#FFA82E", text:"1주 이상 접촉 없음" };
      return { name: "양호", color: "#17DB14", text:"1주 이내 접촉 함" };
    }

    function toggleTag(tag) {
      const index = selectedTags.value.indexOf(tag);
      if (index > -1) {
        selectedTags.value.splice(index, 1);
      } else {
        selectedTags.value.push(tag);
      }
      applyAllFilters();
    }

    function toggleAllTags() {
      selectedTags.value = [];
      applyAllFilters();
    }

    function applyAllFilters() {
      CustomerList.value.forEach(customer => {
        const searchValue = (searchRef.value || '').toLowerCase().trim();
        
        let matchSearch = true;
        if (searchValue) {
          const nameMatch = (customer.name || '').toLowerCase().includes(searchValue);
          const phoneMatch = (customer.phone || '').includes(searchValue);
          matchSearch = nameMatch || phoneMatch;
        }

        let customerTags = customer.tags;
        if (typeof customerTags === 'string') {
          try {
            customerTags = JSON.parse(customerTags || '[]');
          } catch (e) {
            customerTags = [];
          }
        }
        if (!Array.isArray(customerTags)) {
          customerTags = [];
        }

        const matchTags =
          selectedTags.value.length === 0 ||
          selectedTags.value.every(tag => customerTags.includes(tag));

        const matchBookmark = 
          sortMode.value !== 'bookmark' || 
          customer.bookmark_idx;

        customer.opt_visible = matchSearch && matchTags && matchBookmark;
      });
    }

    function viewCustomer(b, customer) {
      if (!b) {
        viewer_show.value = false;
        return;
      } else {
        editingCustomer.value = { ...customer };
        viewer_show.value = true;
      }
    }

    const searchRef = ref('');
    function searchInput() {
      applyAllFilters();
    }

    function editDialogSwitch(bool) {
      dialog_show.value = bool;
    }

    async function fetchCustomers() {
      const rootSql = `
        SELECT 
          c.*,
          (
            SELECT COUNT(*) 
            FROM customer_relations r 
            WHERE r.customer_idx = c.idx OR r.link_to = c.idx
          ) AS rel_cnt,
          b.idx AS bookmark_idx,
          (
            SELECT COUNT(*) - 1
            FROM customers c2 
            WHERE c2.mb_id = c.mb_id AND c2.name = c.name
          ) AS same_name_count,
          (
            SELECT COUNT(*) + 1
            FROM customers c3 
            WHERE c3.mb_id = c.mb_id 
              AND c3.name = c.name 
              AND c3.created_at < c.created_at
          ) AS same_name_order
        FROM customers c
        LEFT JOIN bookmark b
          ON b.mb_id = '${getMbid()}'
          AND b.target_table = 'customers'
          AND b.target_idx = c.idx
        WHERE c.mb_id = '${getMbid()}'
        ORDER BY c.created_at DESC;
      `;
      const result = await sql_query(rootSql);

      CustomerList.value = [];

      console.log("sql_query result:", result);

      const rootCustomers = Array.isArray(result) ? result : result?.results ? result.results : [];

      if (rootCustomers.length === 0) {
        console.log("No customers found.");
        return;
      }

      CustomerList.value = rootCustomers.map(c => ({
        idx: c.idx,
        name: c.name,
        phone: c.phone,
        nickname: c.nickname,
        title: c.title,
        mb_id: c.mb_id,
        m_type: c.m_type,
        sex: c.sex,
        birth: c.birth,
        rrn: c.rrn,
        address: c.address,
        location: c.location,
        ex_address: c.ex_address,
        job: c.job,
        job_grade: c.job_grade,
        job_name: c.job_name,
        job_adrs: c.job_address,
        family: c.family,
        notes: c.notes,
        extra_info: c.extra_info,
        sns_talk: c.sns_talk,
        sns_ama: c.sns_ama,
        sns_etc: c.sns_etc,
        created_at: c.created_at,
        thumb: c.image || basic_profile_url,
        opt_visible: true,
        med_history: c.med_history,
        manage_rank : c.manage_rank,
        vip_rank : c.vip_rank,
        is_offical : c.is_offical,
        is_keyman : c.is_keyman,
        last_touch: c.last_touch,
        rel_cnt: c.rel_cnt,
        bookmark_idx: c.bookmark_idx,
        tags: typeof c.tags === 'string' ? JSON.parse(c.tags || '[]') : (c.tags || []),
        same_name_count: c.same_name_count,
        same_name_order: c.same_name_order,
      }));
    }
    fetchCustomers();

    function editCustomer(customer) {
      editingCustomer.value = { ...customer };
      editDialogSwitch(true);
    }

    async function deleteCustomer(customer) {
      if (confirm(`정말로 ${customer.name} 고객을 삭제하시겠습니까?`)) {
        await sql_query(`DELETE FROM customers WHERE idx = ${customer.idx}`);
        fetchCustomers();
      }
    }

    const CsutomerRegisterVisible = ref(false);
    function registerDialogSwitch(b) { CsutomerRegisterVisible.value = b; }
    function stepByStepMakeCustomer() {
      registerDialogSwitch(true);
    }

    function makeCustomer() {
      editingCustomer.value = {
        idx: null,
        name: '새 고객',
        nickname: '새 고객',
        title: "고객님",
        m_type: 'X0',
        rrn: '19100101-1234567',
        birth: '',
        sex: '0',
        address: '',
        location: '',
        ex_address: '',
        phone: '010-',
        job: '',
        job_grade: '',
        job_name: '',
        job_dept: '',
        job_address: '',
        notes: '',
        med_history: '',
        tags: '',
        is_keyman: '0',
        is_offical: '0',
        vip_rank : '0',
        manage_rank : '0',
        extra_info: '',
        sns_talk : '',
        sns_ama : '',
        sns_etc : '',
        thumb: basic_profile_url,
        opt_visible: true,
        last_touch: '',
      };
      editDialogSwitch(true);
    }

    async function getContactFromAMA() {
      loadVisible.value = true;
      const formData = new FormData();
      formData.append('mb_id', member_info.mb_id);

      let res = await axios.post('https://amadiary.com/api/getContactInfo.php', formData);

      if (res.data?.rows.length > 0) {
        for (const el of res.data.rows) {
          if (el.mb_hp && CustomerList.value.find(c => c.phone === el.mb_hp)) continue;

          const tagArr = el.grp
            ? el.grp.split('|').map(t => t.trim()).filter(Boolean)
            : [];

          for (const tag of tagArr) {
            await ensureCustomerTag(member_info.mb_id, tag);
          }

          const tags = tagArr.length > 0 ? JSON.stringify(tagArr) : null;
          const address = [el.mb_addr1, el.mb_addr2].filter(a => a).join(' ').trim() || null;
          const sex = el.mb_sex === '남' ? 1 : el.mb_sex === '여' ? 2 : 0;

          const sql = `
            INSERT INTO customers SET 
              mb_id = '${member_info.mb_id}',
              name = '${el.mb_name || ''}',
              nickname = '${el.mb_name || ''}',
              m_type = 'X0',
              phone = '${el.mb_hp || ''}',
              birth = ${el.mb_birth ? `'${el.mb_birth}'` : 'NULL'},
              sex = ${sex},
              address = ${address ? `'${address}'` : 'NULL'},
              job = ${el.mb_job ? `'${el.mb_job}'` : 'NULL'},
              rrn = ${el.mb_jumin ? `'${el.mb_jumin}'` : 'NULL'},
              notes = ${el.mb_memo ? `'${el.mb_memo.replace(/'/g, "\\'")}'` : 'NULL'},
              tags = ${tags ? `'${tags}'` : 'NULL'},
              vip_rank = ${parseInt(el.mb_rank) || 0},
              created_at = '${el.mb_datetime || new Date().toISOString().slice(0, 19).replace('T', ' ')}'
          `;
          
          // 등록 성공 후 자동으로 마일스톤 체크
          checkCustomerMilestone(member_info.mb_id);

          await sql_query(sql);
          window.dispatchEvent(new CustomEvent('customer-updated'));
        }
      }
      
      await reloadForSync();
      loadVisible.value = false;
    }

    async function ensureCustomerTag(mb_id, tagName) {
      const sql = `
        INSERT INTO customer_tag (mb_id, name)
        SELECT '${mb_id}', '${tagName}'
        FROM DUAL
        WHERE NOT EXISTS (
          SELECT 1 FROM customer_tag
          WHERE mb_id = '${mb_id}'
            AND name = '${tagName}'
        )
      `;
      await sql_query(sql);
    }


    function dateToDays(dateString) {
      const date = new Date(dateString);
      const now = new Date();
      date.setHours(0, 0, 0, 0);
      now.setHours(0, 0, 0, 0);
      const diff = now - date;
      return Math.floor(diff / (1000 * 60 * 60 * 24));
    }

    const sortState = ref({
      field: null,
      direction: null
    });

    function toggleSort(field) {
      sortMode.value = '';
      
      if (sortState.value.field === field) {
        if (sortState.value.direction === null) {
          sortState.value.direction = 'asc';
        } else if (sortState.value.direction === 'asc') {
          sortState.value.direction = 'desc';
        } else {
          sortState.value.direction = null;
          sortState.value.field = null;
        }
      } else {
        sortState.value.field = field;
        sortState.value.direction = 'asc';
      }

      applySorting();
    }

    function getSortIcon(field) {
      if (sortState.value.field !== field) {
        return 'ph ph-arrows-down-up';
      }
      
      if (sortState.value.direction === 'asc') {
        return 'ph ph-arrow-up';
      } else if (sortState.value.direction === 'desc') {
        return 'ph ph-arrow-down';
      }
      
      return 'ph ph-arrows-down-up';
    }

    function applySorting() {
      if (sortMode.value === 'bookmark') {
        return;
      }
      
      if (!sortState.value.field || !sortState.value.direction) {
        CustomerList.value.sort((a, b) => {
          return new Date(b.created_at) - new Date(a.created_at);
        });
        return;
      }

      const field = sortState.value.field;
      const direction = sortState.value.direction;
      const multiplier = direction === 'asc' ? 1 : -1;

      CustomerList.value.sort((a, b) => {
        let valueA = a[field];
        let valueB = b[field];

        if (field === 'tags') {
          valueA = Array.isArray(valueA) ? valueA.length : 0;
          valueB = Array.isArray(valueB) ? valueB.length : 0;
        }

        if (field === 'last_touch') {
          valueA = dateToDays(valueA);
          valueB = dateToDays(valueB);
        }

        if (valueA == null) valueA = '';
        if (valueB == null) valueB = '';

        if (typeof valueA === 'number' && typeof valueB === 'number') {
          return (valueA - valueB) * multiplier;
        }

        return String(valueA).localeCompare(String(valueB), 'ko-KR') * multiplier;
      });
    }

    function genderChoser(code) {
      if (!code || code == 0) {
        return '무'
      }
      return code % 2 === 0 ? '여' : '남'
    }

    function reloadForSync() {
      fetchCustomers();
      reloadTagList();
    }

    function shareLink(link) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(link)
          .then(() => alert('링크가 복사되었습니다.\n고객님에게 보내주세요'))
        return;
      }
    }

    function formatBirth(yyMMdd) {
      if (!/^\d{6}$/.test(yyMMdd)) return '';
      const mm = yyMMdd.slice(2, 4);
      const dd = yyMMdd.slice(4, 6);
      return `${mm}월 ${dd}일`;
    }

    const MANAGE_MAP = {
      1: 'PB',
      2: 'PS',
      3: 'TA',
      4: 'AP',
      5: 'FF',
      6: 'PC',
      7: 'CS',
    };

    function manageText(value) {
      return MANAGE_MAP[value] || '';
    }

    function getDistinguishInfo(customer) {
      const parts = [];
      
      if (customer.location) {
        parts.push(customer.location);
      }
      
      if (customer.nickname && customer.nickname !== customer.name) {
        parts.push(customer.nickname);
      }
      
      if (customer.rrn) {
        const age = calculateInsuAge(customer.rrn.split('-')[0]);
        if (age) {
          parts.push(`${age}세`);
        }
      }
      
      if (customer.rrn) {
        const genderCode = customer.rrn.split('-')[1]?.slice(0, 1);
        const gender = genderChoser(genderCode);
        if (gender && gender !== '무') {
          parts.push(gender);
        }
      }
      
      if (parts.length === 0 && customer.same_name_count > 0) {
        return `(${customer.same_name_order || 1})`;
      }
      
      return parts.length > 0 ? `(${parts.join(' / ')})` : '';
    }

    return {
      getMbid,
      CustomerList,
      dialog_show,
      editingCustomer,
      editCustomer,
      editDialogSwitch,
      deleteCustomer,
      makeCustomer,
      fetchCustomers,
      calculateInsuAge,
      searchRef,
      searchInput,
      viewer_show,
      viewCustomer,
      loadVisible,
      getContactFromAMA,
      formatKRPhone,
      menuType,
      riskLevel,
      myAllTags,
      selectedTags,
      toggleTag,
      dateToDays,
      getLastTouchRate,
      sortMode,
      sortState,
      toggleSort,
      getSortIcon,
      applySorting,
      toggleAllTags,
      reloadForSync,
      genderChoser,
      tag_edit_show,
      tagEditSwitch,
      reloadTagList,
      sortByBookmark,
      stepByStepMakeCustomer,
      CsutomerRegisterVisible,
      registerDialogSwitch,
      shareLink,
      layoutMode,
      formatBirth,
      manageText,
      getDistinguishInfo,
      // 메뉴 관련
      moreMenuShow,
      createMenuShow,
      setMenuType,
      setLayoutMode,
      // 편집모드 관련
      editMode,
      selectedCustomers,
      toggleEditMode,
      isSelected,
      toggleSelect,
      toggleSelectAll,
      isAllSelected,
      isPartialSelected,
      handleRowClick,
      batchDelete,
      batchBookmark,
      batchTagDialogShow,
      batchTagMode,
      batchSelectedTag,
      openBatchTagDialog,
      executeBatchTag,
    };
  },
}
</script>



<style scoped>
#dialog-customer-manage-list {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  z-index: 999;
  background: var(--color-surface);
}

.cls {
  width:100%;
  height:100%;
  position:absolute;
  left:0;
  top:0;
  z-index: -1;
}

.paper {
  position: relative;
  width: 100%;
  max-width: 1024px;
  height: 100%;
  max-height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background-color: var(--color-background);
}

/* ========== Header Rows ========== */
.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 16px;
  box-sizing: border-box;
  flex-shrink: 0;
}

.header-row .header-left,
.header-row .header-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* Header Primary (타이틀 + 검색) */
.header-primary {
  height: 56px;
  border-bottom: 1px solid var(--color-border);
}

.header-primary .btn-back {
  width: 40px;
  height: 40px;
  border: none;
  background: none;
  font-size: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-text-primary);
  border-radius: 8px;
  transition: background 0.15s ease;
}

.header-primary .btn-back:hover {
  background: var(--color-surface);
}

.header-primary h1 {
  font-size: var(--font-size-xl);
  font-weight: 700;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.header-primary .count-badge {
  font-size: var(--font-size-sm);
  font-weight: 600;
  background: var(--color-brand);
  color: white;
  padding: 2px 10px;
  border-radius: 12px;
}

.search-box {
  display: flex;
  align-items: center;
  gap: 8px;
  background: var(--color-surface);
  border-radius: 10px;
  padding: 0 12px;
  height: 40px;
  width: 200px;
  transition: all 0.2s ease;
}

.search-box:focus-within {
  background: var(--color-background-light);
  box-shadow: 0 0 0 2px var(--color-brand);
}

.search-box i {
  color: var(--color-text-secondary);
  font-size: 18px;
}

.search-box input {
  border: none;
  background: none;
  outline: none;
  width: 100%;
  font-size: var(--font-size-md);
  color: var(--color-text-primary);
}

.search-box input::placeholder {
  color: var(--color-text-secondary);
}

/* Header Secondary (태그 + 버튼들) */
.header-secondary {
  height: 52px;
  padding-top: 8px;
  padding-bottom: 8px;
}

.header-secondary .header-left {
  flex: 1;
  overflow: hidden;
}

/* 아이콘 버튼 */
.btn-icon {
  width: 40px;
  height: 40px;
  border: none;
  background: var(--color-surface);
  border-radius: 10px;
  font-size: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-text-primary);
  transition: all 0.15s ease;
}

.btn-icon:hover {
  background: var(--color-background-light);
}

.btn-icon.active {
  background: var(--color-brand);
  color: white;
}

/* 태그 목록 */
.tags {
  display: flex;
  align-items: center;
  gap: 8px;
  list-style: none;
  margin: 0;
  padding: 0;
  overflow-x: auto;
  scrollbar-width: none;
}

.tags::-webkit-scrollbar {
  display: none;
}

.tags > li {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 14px;
  box-sizing: border-box;
  border-radius: 18px;
  font-size: var(--font-size-sm);
  font-weight: 500;
  cursor: pointer;
  background: var(--color-surface);
  color: var(--color-text-secondary);
  white-space: nowrap;
  transition: all 0.15s ease;
}

.tags > li:hover {
  background: var(--color-background-light);
}

.tags > li.sel {
  background: var(--color-brand);
  color: white;
}

.tags > li.tag-add {
  width: 36px;
  padding: 0;
}

/* 전체선택 */
.select-all {
  display: flex;
  align-items: center;
  gap: 16px;
}

.checkbox-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: var(--font-size-md);
}

.checkbox-wrapper input[type="checkbox"] {
  width: 20px;
  height: 20px;
  cursor: pointer;
  accent-color: var(--color-brand);
}

.selected-count {
  font-size: var(--font-size-sm);
  background: var(--color-brand);
  color: white;
  padding: 4px 12px;
  border-radius: 16px;
  font-weight: 600;
}

/* ========== More Menu (Ellipsis) ========== */
.more-menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
}

.more-menu {
  position: absolute;
  top: 116px;
  right: 16px;
  background: var(--color-background-light);
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.15);
  z-index: 1001;
  min-width: 200px;
  overflow: hidden;
}

.more-menu ul {
  list-style: none;
  margin: 0;
  padding: 8px 0;
}

.more-menu li {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  font-size: var(--font-size-md);
  cursor: pointer;
  transition: background 0.15s ease;
}

.more-menu li:hover {
  background: var(--color-surface);
}

.more-menu li.active {
  color: var(--color-brand);
  font-weight: 600;
}

.more-menu li.active::after {
  content: '';
  margin-left: auto;
  width: 8px;
  height: 8px;
  background: var(--color-brand);
  border-radius: 50%;
}

.more-menu li.disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.more-menu li.disabled:hover {
  background: none;
}

.more-menu .menu-section-title {
  font-size: var(--font-size-xs);
  color: var(--color-text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 8px 16px 4px;
  cursor: default;
}

.more-menu .menu-section-title:hover {
  background: none;
}

.more-menu .menu-divider {
  height: 1px;
  background: var(--color-border);
  margin: 8px 0;
  padding: 0;
  cursor: default;
}

.more-menu .menu-divider:hover {
  background: var(--color-border);
}

/* ========== Create Menu ========== */
.create-menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.3);
  z-index: 1000;
}

.create-menu {
  position: absolute;
  bottom: 80px;
  right: 16px;
  background: var(--color-background-light);
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.2);
  z-index: 1001;
  min-width: 280px;
  overflow: hidden;
}

.create-menu ul {
  list-style: none;
  margin: 0;
  padding: 8px;
}

.create-menu li {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  border-radius: 12px;
  cursor: pointer;
  transition: background 0.15s ease;
}

.create-menu li:hover {
  background: var(--color-surface);
}

.create-menu li i {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-brand);
  color: white;
  border-radius: 12px;
  font-size: 20px;
}

.create-menu li div {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.create-menu li span {
  font-size: var(--font-size-md);
  font-weight: 600;
  color: var(--color-text-primary);
}

.create-menu li small {
  font-size: var(--font-size-xs);
  color: var(--color-text-secondary);
}

/* ========== FAB 버튼 ========== */
.fab-create {
  position: absolute;
  bottom: 24px;
  right: 24px;
  width: 56px;
  height: 56px;
  border-radius: 16px;
  border: none;
  background: var(--color-brand);
  color: white;
  font-size: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 16px rgba(46, 91, 255, 0.4);
  transition: all 0.2s ease;
  z-index: 100;
}

.fab-create:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 20px rgba(46, 91, 255, 0.5);
}

.fab-create:active {
  transform: scale(0.95);
}

/* ========== Container & Content ========== */
.container-item {
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  box-sizing: border-box;
  overflow: hidden;
}

.main-content {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  border-radius: 12px;
}

.main-content::-webkit-scrollbar {
  display: none;
}

.main-content > ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.main-content > ul > li {
  position: relative;
  width:100%;
  display: flex;
  justify-content: start;
  align-items: center;
  border-radius: 12px;
  gap: 12px;
  cursor: pointer;
  flex: 1;
  font-size: var(--font-size-md);
  padding: 8px;
  transition: background 0.15s ease;
}

.main-content > ul > li:hover {
  background: var(--color-surface);
}

.main-content > ul > li.selected-row {
  background: rgba(46, 91, 255, 0.1);
}

.main-content > ul > li > div {
  display: flex;
  align-items: center;
  justify-content: center;
  flex:1;
  width:100%;
}

.main-content > ul > li > div:first-child {
  align-items: center;
  justify-content: start;
}

.main-content > ul > li > div > div > img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 12px;
  background: var(--color-background-light);
}

.main-content > ul > li > div button {
  font-size: var(--font-size-lg);
  color: var(--color-text-primary);
  background: none;
  border: none;
  width:40px;
  height:40px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.1s ease;
}

.main-content > ul > li > div button:hover {
  background: var(--color-background);
}

/* Chapter (테이블 헤더) */
.chapter {
  display: flex;
  align-items: center;
  height: 40px;
  width: 100%;
  border-radius: 10px;
  background: var(--color-surface);
  gap: 12px;
  padding: 0 8px;
}

.chapter > span {
  flex: 1;
  font-size: var(--font-size-sm);
  font-weight: 600;
  color: var(--color-text-secondary);
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.chapter > span > button {
  font-size: var(--font-size-md);
  color: var(--color-text-secondary);
  background: none;
  border: none;
  width: 28px;
  height: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.1s ease;
}

.chapter > span > button:hover {
  background: var(--color-background-light);
}

.chapter > span > button:has(.ph-arrow-up),
.chapter > span > button:has(.ph-arrow-down) {
  background: var(--color-brand);
  color: white;
}

/* ========== Batch Action Bar ========== */
.batch-action-bar {
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  box-sizing: border-box;
  background: var(--color-surface-reverse);
  color: var(--color-surface);
  flex-shrink: 0;
}

.batch-info {
  font-size: var(--font-size-md);
}

.batch-info strong {
  color: var(--color-brand-light, #7B9FFF);
}

.batch-actions {
  display: flex;
  gap: 8px;
}

.batch-actions button {
  height: 36px;
  padding: 0 12px;
  border-radius: 8px;
  border: none;
  background: rgba(255,255,255,0.15);
  color: inherit;
  font-size: var(--font-size-sm);
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.15s ease;
}

.batch-actions button:hover:not(:disabled) {
  background: rgba(255,255,255,0.25);
}

.batch-actions button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.batch-actions button.danger {
  background: #E3204A;
}

.batch-actions button.danger:hover:not(:disabled) {
  background: #ff3366;
}

/* ========== Batch Tag Dialog ========== */
.batch-tag-dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
}

.batch-tag-content {
  background: var(--color-background);
  border-radius: 16px;
  padding: 24px;
  width: 90%;
  max-width: 360px;
}

.batch-tag-content h3 {
  margin: 0 0 8px 0;
  font-size: var(--font-size-lg);
}

.batch-tag-content p {
  margin: 0 0 16px 0;
  color: var(--color-text-secondary);
  font-size: var(--font-size-sm);
}

.batch-tag-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  max-height: 200px;
  overflow-y: auto;
  margin-bottom: 16px;
}

.batch-tag-list li {
  padding: 8px 16px;
  background: var(--color-surface);
  border-radius: 20px;
  cursor: pointer;
  font-size: var(--font-size-sm);
  transition: all 0.15s ease;
  border: 2px solid transparent;
}

.batch-tag-list li:hover {
  background: var(--color-background-light);
}

.batch-tag-list li.selected {
  background: var(--color-brand);
  color: white;
  border-color: var(--color-brand);
}

.batch-tag-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.batch-tag-actions button {
  padding: 10px 20px;
  border-radius: 8px;
  border: 1px solid var(--color-border);
  background: var(--color-background);
  cursor: pointer;
  font-size: var(--font-size-md);
}

.batch-tag-actions button.primary {
  background: var(--color-brand);
  color: white;
  border: none;
}

.batch-tag-actions button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ========== Grid View ========== */
.container-grid {
  padding: 16px;
}

.grid-content {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 16px;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding: 4px;
}

.grid-content::-webkit-scrollbar {
  display: none;
}

.customer-card {
  position: relative;
  background: var(--color-surface);
  border-radius: 16px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 2px solid transparent;
}

.customer-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  border-color: var(--color-brand);
}

.customer-card.selected-card {
  border-color: var(--color-brand);
  background: rgba(46, 91, 255, 0.1);
}

.card-bookmark {
  position: absolute;
  top: 12px;
  right: 12px;
  color: var(--color-brand);
  font-size: 18px;
}

.card-thumb {
  position: relative;
  width: 72px;
  height: 72px;
  border-radius: 50%;
  overflow: visible;
  border: 3px solid var(--color-background);
}

.card-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.card-thumb.edit-mode img {
  opacity: 0.7;
}

.card-thumb.checked img {
  opacity: 0.5;
}

.card-thumb.checked {
  border-color: var(--color-brand);
}

.card-thumb .thumb-check {
  position: absolute;
  bottom: -2px;
  right: -2px;
  width: 26px;
  height: 26px;
  font-size: 24px;
}

.card-info {
  text-align: center;
  width: 100%;
}

.card-info h3 {
  margin: 0;
  font-size: var(--font-size-lg);
  color: var(--color-text-primary);
  font-weight: 600;
}

.card-info .card-title {
  margin: 4px 0 0 0;
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
}

.card-tags {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 4px;
  margin-top: 8px;
}

.card-tags span {
  font-size: 11px;
  padding: 2px 8px;
  background: var(--color-background);
  border-radius: 12px;
  color: var(--color-text-secondary);
}

.card-meta {
  display: flex;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding-top: 8px;
  border-top: 1px solid var(--color-border);
}

.card-meta .m-type {
  font-size: 12px;
  font-weight: 700;
  padding: 2px 8px;
  background: #FFBABA;
  color: #000;
  border-radius: 4px;
}

.card-meta .birth {
  font-size: 12px;
  color: var(--color-text-secondary);
}

/* ========== Responsive - Desktop ========== */
@media (min-width: 1025px) {
  #dialog-customer-manage-list {
    padding: 16px;
    background: rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(4px);
  }
  
  .paper {
    max-width: 1024px;
    max-height: 90%;
    border-radius: 20px;
    box-shadow: 0 8px 40px rgba(0, 0, 0, 0.2);
  }
  
  .fab-create {
    bottom: 32px;
    right: 32px;
  }
  
  .batch-action-bar {
    border-radius: 0 0 20px 20px;
  }
}

/* ========== Misc ========== */
.download-loading {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  padding:16px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  z-index: 99999;
  background: var(--color-surface);
  backdrop-filter: blur(2px);
}

.bookmark {
  color: var(--color-brand);
  position: absolute;
  left: 32px;
  bottom: -4px;
  font-size: 18px;
  margin: 0;
  padding: 0;
}

.m_type { 
  width: 36px; 
  height: 36px; 
  color: #000; 
  display: flex; 
  align-items: center; 
  justify-content: center; 
  border-radius: 8px; 
  font-weight: 700; 
  font-size: 13px;
}

.m_type.X { background: #FFB4B3; }
.m_type.Y { background: #E3FFBD; }
.m_type.Z { background: #B5D5FF; }

/* 배지 */
.badges {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: 8px;
}

.badge {
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
  color: #fff;
  white-space: nowrap;
}

.badge-samename {
  background: #ff9800;
  color: #000;
  font-size: 10px;
  padding: 2px 6px;
}

.distinguish-info {
  font-size: 12px;
  color: var(--color-text-secondary);
  margin-left: 4px;
  font-weight: 400;
}

/* 썸네일 + 체크박스 */
.thumb-wrapper {
  position: relative;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  margin-right: 12px;
}

.thumb-wrapper img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--color-background-light);
  object-fit: cover;
  transition: all 0.2s ease;
}

.thumb-wrapper.edit-mode img {
  opacity: 0.7;
}

.thumb-wrapper.checked img {
  opacity: 0.5;
  background: var(--color-brand);
  box-sizing: border-box;
  padding: 2px;
}

.thumb-check {
  position: absolute;
  bottom: -4px;
  right: -4px;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-background);
  border-radius: 50%;
  font-size: 20px;
  color: var(--color-text-secondary);
  box-shadow: 0 2px 6px rgba(0,0,0,0.15);
  cursor: pointer;
  transition: all 0.15s ease;
}

.thumb-wrapper.checked .thumb-check {
  background: var(--color-brand);
  color: white;
}

/* ========== Responsive ========== */
@media (max-width: 768px) {
  .search-box {
    width: 140px;
  }
  
  .grid-content {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .batch-actions button span {
    display: none;
  }
  
  .more-menu {
    right: 8px;
  }
  
  .create-menu {
    right: 8px;
    left: 8px;
    min-width: auto;
  }
}

@media (max-width: 480px) {
  .header-primary h1 {
    font-size: var(--font-size-lg);
  }
  
  .search-box {
    width: 120px;
  }
  
  .tags > li {
    padding: 0 10px;
    font-size: var(--font-size-xs);
  }
}

/* 태블릿/모바일: 전체화면 */
@media (max-width: 1024px) {
  #dialog-customer-manage-list {
    padding: 0;
  }
  
  .paper {
    max-width: 100%;
    max-height: 100%;
    border-radius: 0;
  }
  
  .batch-action-bar {
    border-radius: 0;
  }
}

/* 데스크톱: dialog 스타일 */
@media (min-width: 1025px) {
  #dialog-customer-manage-list {
    padding: 24px;
    background: rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(4px);
  }
  
  .paper {
    max-width: 1024px;
    max-height: 90%;
    border-radius: 20px;
    box-shadow: 0 8px 40px rgba(0, 0, 0, 0.2);
  }
  
  .fab-create {
    bottom: 32px;
    right: 32px;
  }
  
  .batch-action-bar {
    border-radius: 0 0 20px 20px;
  }
}
</style>